import Vue from "vue"
import store from "@/store"

export default new Vue({
  store,

  methods: {
    listen(events, callbacks) {
      window._.forEach(window.Arr.wrap(events), (event) => {
        window._.forEach(window.Arr.wrap(callbacks), (callback) => {
          this.$on(event, callback);
        });
      });
    },

    silence(events, callbacks) {
      window._.forEach(window.Arr.wrap(events), (event) => {
        window._.forEach(window.Arr.wrap(callbacks), (callback) => {
          this.$off(event, callback);
        });
      });
    },

    dispatch(events, ...args) {
      window._.forEach(window.Arr.wrap(events), (event) => {
        this.$emit(event, ...args);
      });
    },
  },
});
